import * as Sentry from '@sentry/react'
import { config, isLocal } from './config'
import { BrowserTracing } from '@sentry/tracing'
import React from 'react'
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
    Routes,
} from 'react-router-dom'

if (!isLocal()) {
    Sentry.init({
        ...config.sentry,
        tracesSampleRate: 0.1,
        release: config.commitHash,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV6Instrumentation(
                    React.useEffect,
                    useLocation,
                    useNavigationType,
                    createRoutesFromChildren,
                    matchRoutes
                ),
            }),
        ],
    })
}

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

export const sentry = Sentry
